<template>
	<div class="ks-videoeditor-ruler">
		<div class="ks-videoeditor-track-head ks-videoeditor-ruler-head" :style="{width: head_width + 'px'}"></div>
		<div class="ks-videoeditor-ruler-body" ref="origin" @mousedown.prevent="$emit('scrub-down', $event)">
			<div v-for="tick in ticks" :key="tick" class="ks-videoeditor-tick" :style="{left: tick * zoom + 'px'}">
				<span>{{ fmt(tick) }}</span>
			</div>
		</div>
	</div>
</template>

<script>
import {fmt} from './utils.js'

// Time scale above the tracks; pressing it starts scrubbing
export default {
	props: {
		zoom: Number,
		head_width: Number,
		// Width of the scale in px
		width: Number
	},
	computed: {
		ticks () {
			const step = this.zoom >= 80 ? 1 : this.zoom >= 30 ? 5 : this.zoom >= 12 ? 10 : this.zoom >= 5 ? 30 : 60;
			const ticks = [];
			for (let t = 0; t * this.zoom < this.width; t += step) ticks.push(t);
			return ticks;
		}
	},
	methods: {
		fmt,
		time_at (client_x) {
			return (client_x - this.$refs.origin.getBoundingClientRect().left) / this.zoom;
		}
	}
}
</script>
